"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Search/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _SearchWindow = require('./Refined/SearchWindow'); var _SearchWindow2 = _interopRequireDefault(_SearchWindow);








const SearchModal = ({ isOpen, onClose, restore }) => (
  _react2.default.createElement(_Modal2.default, { isOpen: isOpen, onClose: onClose, className: "search-window--modal", __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}
    , _react2.default.createElement(_SearchWindow2.default, { onClose: onClose, restore: restore, __self: this, __source: {fileName: _jsxFileName, lineNumber: 15}} )
  )
)

exports. default = SearchModal
